{
    "CRMConfiguration_Table_Headers_Description": "Description",
    "CRMConfiguration_Table_Headers_Type": "Taper",
    "CRMConfiguration_Table_Headers_TelSys": "Serveur de téléphonie",
    "CRMConfiguration_Table_Headers_Partition": "Partition",
    "CRMConfiguration_Table_Headers_Device": "Appareil",
    "NAME": "CRMConfigurationLanguage"
}